import { Environment, getDebugService } from '@mchs/web-core';

/* eslint-disable mchs-local-rules/no-process-env */
class EnvironmentExtendedUtility {
  private debugLogger = getDebugService();

  constructor() {}

  /**
   * Method for returning the reCAPTCHA site key.
   *
   * @returns String containing the reCAPTCHA site key.
   */
  public getReCAPTCHASiteKey(): string {
    // Log a debug message if the url environment variable isn't set.
    if (!process.env.MCHS_RECAPTCHA_SITE_KEY) {
      this.logMessage('The reCAPTCHA site key is required, but is not set.');
    }

    return process.env.MCHS_RECAPTCHA_SITE_KEY ?? '';
  }

  /**
   * Method for returning the service api key for the application service layer.
   *
   * @returns String containing the service api key.
   */
  public getApiKey(): string {
    // Log a debug message if the service api key environment variable isn't set.
    if (!process.env.MCHS_API_KEY) {
      this.logMessage('The api key is required, but is not set.');
    }

    return process.env.MCHS_API_KEY ?? '';
  }

  /**
   * Method for returning the appointment service name for the application service layer.
   *
   * @returns String containing the appointment service name.
   */
  public getAppointmentServiceName(): string {
    // Log a debug message if the appointment service name environment variable isn't set.
    if (!process.env.MCHS_APPOINTMENT_SERVICE) {
      this.logMessage(
        'The appointment service name is required, but is not set.'
      );
    }

    return process.env.MCHS_APPOINTMENT_SERVICE ?? '';
  }

  /**
   * Method for returning the patient identity service name for the application service layer.
   *
   * @returns String containing the patient identity service name.
   */
  public getPatientIdentityServiceName(): string {
    // Log a debug message if the appointment service name environment variable isn't set.
    if (!process.env.MCHS_PATIENT_IDENTITY_SERVICE) {
      this.logMessage(
        'The patient identity service name is required, but is not set.'
      );
    }

    return process.env.MCHS_PATIENT_IDENTITY_SERVICE ?? '';
  }

  /**
   * Method for returning the reCAPTCHA service name for the application service layer.
   *
   * @returns String containing the reCAPTCHA service name.
   */
  public getReCAPTCHAServiceName(): string {
    // Log a debug message if the reCAPTCHA service name environment variable isn't set.
    if (!process.env.MCHS_RECAPTCHA_SERVICE) {
      this.logMessage(
        'The reCAPTCHA service name is required, but is not set.'
      );
    }

    return process.env.MCHS_RECAPTCHA_SERVICE ?? '';
  }

  /**
   * Method for returning the service My Marshfield Clinic (create) url.
   *
   * @returns String containing the My Marshfield Clinic (create) url.
   */
  public getMyMarshfieldClinicCreateUrl(): string {
    // Log a debug message if the url environment variable isn't set.
    if (!process.env.MCHS_MY_MARSHFIELD_CLINIC_CREATE) {
      this.logMessage(
        'The My Marshfield Clinic (create) url is required, but is not set.'
      );
    }

    return process.env.MCHS_MY_MARSHFIELD_CLINIC_CREATE ?? '';
  }

  /**
   * Method for returning the service My Marshfield Clinic (sign in) url.
   *
   * @returns String containing the My Marshfield Clinic (sign in) url.
   */
  public getMyMarshfieldClinicSignInUrl(): string {
    // Log a debug message if the url environment variable isn't set.
    if (!process.env.MCHS_MY_MARSHFILED_CLINIC_SIGN_IN) {
      this.logMessage(
        'The My Marshfield Clinic (sign in) url is required, but is not set.'
      );
    }

    return process.env.MCHS_MY_MARSHFILED_CLINIC_SIGN_IN ?? '';
  }

  /**
   * Method for returning the service Care My Way url.
   *
   * @returns String containing the Care My Way url.
   */
  public getCareMyWayUrl(): string {
    // Log a debug message if the url environment variable isn't set.
    if (!process.env.MCHS_CARE_MY_WAY) {
      this.logMessage('The Care My Way url is required, but is not set.');
    }

    return process.env.MCHS_CARE_MY_WAY ?? '';
  }

  /**
   * Method for returning the Provider Directory url.
   *
   * @returns String containing the Provider Directory url.
   */
  public getProviderDirectoryUrl(): string {
    // Log a debug message if the url environment variable isn't set.
    if (!process.env.MCHS_PROVIDER_DIRECTORY) {
      this.logMessage(
        'The Provider Directory url is required, but is not set.'
      );
    }

    return process.env.MCHS_PROVIDER_DIRECTORY ?? '';
  }

  private logMessage(message: string): void {
    if (Environment.isDevelopmentEnvironment()) {
      this.debugLogger.log('EnvironmentExtended', message);
    }
  }
}

const EnvironmentExtended = new EnvironmentExtendedUtility();
//Object.freeze(EnvironmentExtended);

export default EnvironmentExtended;
